<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="position-relative">
    <input
      ref="input"
      type="text"
      :placeholder="!showAutocomplete ? '' : 'Type here'"
      v-model="text"
      @keyup="keyup"
      @click="showAutocomplete = true"
      @focus="onFocus"
      @blur="onBlur"
    />
    <div class="autocomplete-box" v-if="showAutocomplete">
      <div v-for="(item, index) in search_result" :key="index" :data-index="index" @click="select(item.name)">
        <div>{{ item.name }}</div>
      </div>
      <div v-if="search_result.length == 0" class="add" @click="addItem(text)">
        <i class="icofont-plus-circle text-success" style="font-size: 1.40625rem"></i>Create a new Activity named:<br />
        <div>
          <strong>{{ text }}</strong>
        </div>
      </div>
    </div>
    <div v-if="inputData != '' && !showAutocomplete" class="tag-pill" :title="inputData" @click="clickTag">
      <em> {{ inputData }} </em>
      <a @click="removeAll"><i class="icofont-close-line"></i></a>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "InputTagDropdownTransport",

  props: {
    inputData: String,
  },

  data() {
    return {
      text: [],
      search_result: [],
      showAutocomplete: false,
    };
  },

  computed: {
    ...mapGetters(["tourTransports"]),
  },

  watch: {
    text: function () {
      if (this.text && this.tourTransports != undefined) {
        this.search_result = this.tourTransports.filter((item) => {
          return this.text
            .toLowerCase()
            .split(" ")
            .every((v) => item.name.toLowerCase().includes(v));
        });
      } else {
        this.search_result = this.tourTransports;
      }
    },
  },

  mounted() {},

  methods: {
    select(str) {
      this.text = str;
      this.$emit("update:inputData", this.text);
      this.text = "";
      this.showAutocomplete = false;
    },

    keyup() {
      this.showAutocomplete = true;
    },

    onFocus() {
      this.text = this.inputData;
      this.showAutocomplete = true;
    },

    onBlur() {
      setTimeout(() => (this.showAutocomplete = false), 500);
    },

    closeTravelerDropdown() {
      this.showAutocomplete = false;
    },

    addItem(text) {
      this.text = text;
      this.$emit("update:inputData", this.text);
      this.text = "";
      this.showAutocomplete = false;
    },

    clickTag() {
      this.text = this.inputData;
      this.showAutocomplete = true;
      this.$refs.input.select();
    },

    removeAll() {
      this.text = "";
      this.$emit("update:inputData", this.text);
      this.$refs.input.focus();
      this.text = "";
      this.showAutocomplete = true;
    },
  },
};
</script>

<style scoped>
input {
  padding: 0.125rem 0.625rem 0.25rem;
  height: 1.875rem;
  line-height: 1.125rem;
  font-size: 0.9375rem;
  background-color: #fff;
  appearance: none;
  color: #111;
  font-weight: 400;
  border: 1px solid #ccc;
  border-radius: 0.375rem;
  width: 100%;
  position: relative;
}

input:focus-visible,
input:focus {
  border-color: #2d7ff9 !important;
  border-width: 2px;
  outline: none;
}

.tag-pill {
  position: absolute;
  top: 0.25rem;
  left: 0.375rem;
  display: inline-block;
  padding: 0 0 0 0.3125rem;
  border-radius: 0.25rem;
  background-color: #e9eef9;
  height: 1.375rem;
  line-height: 1.125rem;
  max-width: calc(100% - 12px);
}

.tag-pill em {
  font-size: 0.9375rem;
  appearance: none;
  color: #111;
  font-weight: 400;
  display: inline-block !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: calc(100%);
  overflow: hidden;
  margin-top: 0.125rem;
  padding-right: 1.625rem;
  font-style: normal;
}
a {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 0.3125rem;
  top: 0.1875rem;
}
a:hover {
  background-color: #bfd7d7;
  cursor: pointer;
}
a i {
  pointer-events: none;
  margin: 0;
  padding: 0;
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  top: 0.15rem;
  left: 0.1rem;
  background-size: 0.5rem 0.5rem;
}
.autocomplete-box {
  position: absolute;
  z-index: 50;
  margin-top: 0.25rem;
  background-color: #fff;
  box-shadow: 2px 2px 5px 0 rgb(15 15 15 / 20%);
  overflow: auto;
  max-height: 25rem;
  min-width: 250px;
  line-height: 1.9375rem;
  font-size: 0.9375rem;
  font-weight: 400;
}

.autocomplete-box > div {
  padding: 0.375rem 1.25rem 0.375rem 0.625rem;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  border: 1px solid #ccc;
}
.autocomplete-box > div.active,
.autocomplete-box > div:hover {
  background-color: #f6fff5;
  border-color: #666;
}

.autocomplete-box > div.add {
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #111;
  padding-left: 2.5rem;
}
.add i {
  position: absolute;
  top: 1.125rem;
  left: 0.625rem;
}
</style>